import React, { useState, useMemo } from "react";
import { NotFound } from "../../components/common/NotFound";
import PaginationComponent from "../common/PaginationComponent";
import DeliveryTermsWorklistRow from "./DeliveryTermsWorklistRow";
import DeliveryTermsSkeletonRow from "./DeliveryTermsSkeletonRow";

const DeliveryTermsGrid = (props) => {
  const {
    filteredResults,
    handleEdit,
    handleDelete,
    handleView,
    loading,
    menuRights,
    moduleName,
  } = props;

  const [count, setCount] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = count;

  const currentTableData = useMemo(() => {
    if (filteredResults?.length <= pageSize) setCurrentPage(1);
    else if (currentPage > Math.ceil(filteredResults?.length / pageSize)) {
      setCurrentPage(1);
    }
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filteredResults?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, filteredResults, count]);

  const showData = currentTableData?.length > 0;
  const showSkeleton = loading === true && !showData;
  const showNotFound = loading !== true && !showData;

  return (
    <>
      {(showData || showSkeleton) && (
        <div className="row table-row mb-4rem">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="quote-worklist-header">
              <div>Delivery Terms</div>
              <div>Description</div>
              <div>Mode of Transport</div>
              <div>Status</div>
              <div></div>
            </div>

            {showData &&
              currentTableData.map((items, index) => (
                <DeliveryTermsWorklistRow
                  key={items?.id}
                  item={items}
                  rowIndex={index}
                  menuRights={menuRights}
                  handleView={handleView}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              ))}

            {showSkeleton &&
              Array.from({ length: 10 }).map((_, index) => (
                <DeliveryTermsSkeletonRow key={index} rowIndex={index} />
              ))}
          </div>
        </div>
      )}
      {showNotFound && <NotFound />}
      {showData && (
        <PaginationComponent
          count={count}
          setCount={setCount}
          pageSize={pageSize}
          currentPage={currentPage}
          filteredResults={filteredResults}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
};

export default DeliveryTermsGrid;